import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import _ from 'lodash';

const modules = import.meta.glob('./translation-files/*.yaml', { eager: true });

const resources = {};

Object.entries(modules).forEach(([path, module]) => {
  const [, file] = path.match(/\.\/translation-files\/(.*)\.yaml$/);
  const [lang, slug] = file.split('.');

  resources[slug] ??= {};
  resources[slug][lang] = module.default;
});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: ['en'],
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
